import template from './auth.json' with { type: "json" };
import { deriveHdPublicKey, hexToBin, } from '@bitauth/libauth';
import { getWalletSourceOutput, getLibauthCompiler, getWalletInput } from '@unspent/tau';
export const compiler = getLibauthCompiler(template);
export function getAuthLayers(authUtxo, privateKey, addressIndex = 0) {
    let inputs = [];
    let outputs = [];
    let sourceOutputs = [];
    sourceOutputs.push(getWalletSourceOutput(authUtxo, privateKey, addressIndex));
    inputs.push(getWalletInput(authUtxo, privateKey, addressIndex));
    outputs.push(getAuthWalletOutput(authUtxo, privateKey, addressIndex));
    return { inputs, outputs, sourceOutputs };
}
export function getAuthWalletOutput(utxo, privateKey, addressIndex = 0) {
    const lockingBytecode = privateKey ? {
        compiler: compiler,
        data: {
            hdKeys: {
                addressIndex: addressIndex,
                hdPublicKeys: {
                    'wallet': deriveHdPublicKey(privateKey).hdPublicKey
                },
            },
        },
        script: 'wallet_lock'
    } : Uint8Array.from(Array(33));
    return {
        lockingBytecode: lockingBytecode,
        valueSatoshis: BigInt(utxo.value),
        token: utxo.token_data ? {
            category: hexToBin(utxo.token_data.category),
            amount: BigInt(utxo.token_data.amount),
            nft: utxo.token_data.nft ? {
                commitment: hexToBin(utxo.token_data.nft.commitment),
                capability: utxo.token_data.nft.capability,
            } : undefined
        } : undefined
    };
}
//# sourceMappingURL=auth.js.map